"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.string.ends-with.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.for-each.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
/**
 * @typedef {object} TransitionPresenterProps
 * @property {React.ReactNode} children
 * @property {{ path: string } | null} route
 * @property {{ mode: string, props: object }} transitionMap
 * @property {React.ElementType} containerTag
 * @property {React.CSSProperties} containerStyle
 */

/**
 * Keep scroll offsets visible in a cloned page during its exit animation.
 * @param {HTMLElement} source
 * @param {HTMLElement} copy
 */
function copyScrollState(source, copy) {
  copy.scrollLeft = source.scrollLeft;
  copy.scrollTop = source.scrollTop;
  for (var index = 0; index < source.children.length; index += 1) {
    copyScrollState(source.children[index], copy.children[index]);
  }
}

/**
 * Animate a visual snapshot instead of mounting a second copy of the route.
 * This leaves a single live KeepAlive tree in the stable current container.
 * @extends {React.Component<TransitionPresenterProps>}
 */
class TransitionViewPresenter extends _react.default.Component {
  constructor() {
    super(...arguments);
    (0, _defineProperty2.default)(this, "stage", null);
    (0, _defineProperty2.default)(this, "currentNode", null);
    (0, _defineProperty2.default)(this, "snapshotNode", null);
    (0, _defineProperty2.default)(this, "animationTimer", null);
    (0, _defineProperty2.default)(this, "setContainerRef", node => {
      var _this$props$setContai, _this$props;
      (_this$props$setContai = (_this$props = this.props).setContainerRef) === null || _this$props$setContai === void 0 || _this$props$setContai.call(_this$props, node);
    });
  }
  getSnapshotBeforeUpdate(previousProps) {
    var _previousProps$route, _this$props$route;
    if (((_previousProps$route = previousProps.route) === null || _previousProps$route === void 0 ? void 0 : _previousProps$route.path) === ((_this$props$route = this.props.route) === null || _this$props$route === void 0 ? void 0 : _this$props$route.path) || !this.currentNode) return null;
    var onExit = this.props.transitionMap.props.onExit;
    if (onExit) onExit(this.currentNode);
    var snapshot = this.currentNode.cloneNode(true);
    copyScrollState(this.currentNode, snapshot);
    return snapshot;
  }
  componentDidUpdate(_previousProps, _previousState, snapshot) {
    var _transitionProps$getT, _timings$exitDuration;
    if (!snapshot || !this.stage || !this.currentNode) return;
    this.finishAnimation();
    var transitionMap = this.props.transitionMap;
    var transitionProps = transitionMap.props;
    var classNames = typeof transitionProps.classNames === 'function' ? transitionProps.classNames() : transitionProps.classNames;
    if (!classNames) return;
    var outgoing = snapshot;
    // A rapid navigation may clone the previous entrance before it finishes.
    Array.from(outgoing.classList).forEach(name => {
      if (name.endsWith('-enter') || name.endsWith('-enter-active')) outgoing.classList.remove(name);
    });
    outgoing.setAttribute('aria-hidden', 'true');
    outgoing.style.pointerEvents = 'none';
    outgoing.style.position = 'absolute';
    outgoing.style.top = '0';
    outgoing.style.left = '0';
    outgoing.style.width = '100%';
    this.stage.insertBefore(outgoing, this.currentNode);
    this.snapshotNode = outgoing;
    outgoing.classList.add(`${classNames}-exit`);
    this.currentNode.classList.add(`${classNames}-enter`);
    if (transitionProps.onExitSnapshot) transitionProps.onExitSnapshot(outgoing);
    if (transitionProps.onEnter) transitionProps.onEnter(this.currentNode);
    // Commit the entering node's initial transform/opacity before activating it.
    this.currentNode.getBoundingClientRect();
    var duration = transitionProps.timeout || 0;
    var timings = ((_transitionProps$getT = transitionProps.getTimings) === null || _transitionProps$getT === void 0 ? void 0 : _transitionProps$getT.call(transitionProps, classNames)) || {};
    var enterDelay = timings.enterDelay || 0;
    outgoing.style.transitionDuration = `${(_timings$exitDuration = timings.exitDuration) !== null && _timings$exitDuration !== void 0 ? _timings$exitDuration : duration}ms`;
    outgoing.style.webkitTransitionDuration = outgoing.style.transitionDuration;
    outgoing.style.transitionDelay = '0ms';
    outgoing.style.webkitTransitionDelay = '0ms';
    this.currentNode.style.transitionDuration = `${duration - enterDelay}ms`;
    this.currentNode.style.webkitTransitionDuration = this.currentNode.style.transitionDuration;
    this.currentNode.style.transitionDelay = `${enterDelay}ms`;
    this.currentNode.style.webkitTransitionDelay = this.currentNode.style.transitionDelay;
    outgoing.classList.add(`${classNames}-exit-active`);
    this.currentNode.classList.add(`${classNames}-enter-active`);
    if (transitionProps.onEntering) transitionProps.onEntering(this.currentNode);
    var finish = () => {
      if (this.snapshotNode === outgoing) this.finishAnimation();
    };
    if (transitionProps.addEndListener) {
      var coverExit = !classNames.includes('fade-slide') && /slide-(?:right|(?:up|down)-back)/.test(classNames);
      var target = coverExit ? outgoing : this.currentNode;
      transitionProps.addEndListener(target, finish);
    }
    this.animationTimer = setTimeout(finish, (transitionProps.timeout || 0) + 50);
  }
  componentWillUnmount() {
    this.finishAnimation();
  }
  finishAnimation() {
    if (this.animationTimer) clearTimeout(this.animationTimer);
    this.animationTimer = null;
    var transitionMap = this.props.transitionMap;
    var transitionProps = transitionMap.props;
    var outgoing = this.snapshotNode;
    if (!outgoing) return;
    if (transitionProps.onExited) transitionProps.onExited(outgoing);
    if (transitionProps.onEntered && this.currentNode) transitionProps.onEntered(this.currentNode);
    if (this.currentNode) {
      Array.prototype.forEach.call(Array.from(this.currentNode.classList), name => {
        var _this$currentNode;
        if (name.endsWith('-enter') || name.endsWith('-enter-active')) (_this$currentNode = this.currentNode) === null || _this$currentNode === void 0 || _this$currentNode.classList.remove(name);
      });
      this.currentNode.style.transitionDuration = '';
      this.currentNode.style.webkitTransitionDuration = '';
      this.currentNode.style.transitionDelay = '';
      this.currentNode.style.webkitTransitionDelay = '';
    }
    if (outgoing.parentNode) outgoing.parentNode.removeChild(outgoing);
    this.snapshotNode = null;
  }
  render() {
    var _this$props2 = this.props,
      children = _this$props2.children,
      containerTag = _this$props2.containerTag,
      containerStyle = _this$props2.containerStyle;
    return /*#__PURE__*/_react.default.createElement('div', {
      ref: node => {
        this.stage = node;
      },
      style: {
        position: 'relative',
        height: '100%',
        overflow: 'hidden'
      }
    }, /*#__PURE__*/_react.default.createElement('div', {
      ref: node => {
        this.currentNode = node;
      },
      style: {
        height: '100%'
      }
    }, /*#__PURE__*/_react.default.createElement(containerTag, {
      style: containerStyle,
      ref: this.setContainerRef
    }, children)));
  }
}
exports.default = TransitionViewPresenter;